import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth, homePathFor } from "./context/AuthContext";
import Layout from "./components/Layout";
import LoginPage from "./pages/LoginPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import RequesterHome from "./pages/RequesterHome";
import NewReportWizard from "./pages/NewReportWizard";
import ReportDetail from "./pages/ReportDetail";
import ValidatorPage from "./pages/ValidatorPage";
import ArbitrationPage from "./pages/ArbitrationPage";
import AccountingPage from "./pages/AccountingPage";
import AdminPage from "./pages/AdminPage";

function FullScreenLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f8fafc]">
      <div className="text-center animate-enter">
        <img src="/assets/favicon.png" alt="" className="h-16 w-16 mx-auto mb-4" />
        <p className="text-lg font-semibold text-slate-600">Chargement…</p>
      </div>
    </div>
  );
}

function Protected({ roles, children }) {
  const { user, hasRole } = useAuth();
  const location = useLocation();
  if (user === undefined) return <FullScreenLoader />;
  if (user === null) return <Navigate to="/connexion" state={{ from: location.pathname }} replace />;
  if (roles && !hasRole(...roles)) return <Navigate to={homePathFor(user)} replace />;
  return children;
}

function RootRedirect() {
  const { user } = useAuth();
  if (user === undefined) return <FullScreenLoader />;
  if (user === null) return <Navigate to="/connexion" replace />;
  return <Navigate to={homePathFor(user)} replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/connexion" element={<LoginPage />} />
      <Route path="/mot-de-passe-oublie" element={<ResetPasswordPage mode="forgot" />} />
      <Route path="/reinitialiser" element={<ResetPasswordPage mode="reset" />} />
      <Route path="/activer" element={<ResetPasswordPage mode="activate" />} />
      <Route path="/" element={<RootRedirect />} />
      <Route element={<Protected><Layout /></Protected>}>
        <Route path="/accueil" element={<Protected roles={["demandeur"]}><RequesterHome /></Protected>} />
        <Route path="/nouvelle-note" element={<Protected roles={["demandeur"]}><NewReportWizard /></Protected>} />
        <Route path="/nouvelle-note/:reportId" element={<Protected roles={["demandeur"]}><NewReportWizard /></Protected>} />
        <Route path="/notes/:reportId" element={<ReportDetail />} />
        <Route path="/validation" element={<Protected roles={["valideur"]}><ValidatorPage /></Protected>} />
        <Route path="/validation/:reportId" element={<Protected roles={["valideur"]}><ValidatorPage /></Protected>} />
        <Route path="/arbitrage" element={<Protected roles={["eveque"]}><ArbitrationPage /></Protected>} />
        <Route path="/arbitrage/:reportId" element={<Protected roles={["eveque"]}><ArbitrationPage /></Protected>} />
        <Route path="/comptabilite" element={<Protected roles={["comptable"]}><AccountingPage /></Protected>} />
        <Route path="/admin" element={<Protected roles={["admin", "super_admin"]}><AdminPage /></Protected>} />
      </Route>
      <Route path="*" element={<RootRedirect />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
